import React, { useState } from 'react';
import { VscEye } from 'react-icons/vsc';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {
  Alert,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Typography,
  // Modal,
  Box,
  Chip
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { BrandStatusUpdate, BrandView } from 'API/Branding';
import { LoadingButton } from '@mui/lab';
import { FaImage } from 'react-icons/fa';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const WithCsp = (props) => {
  const CspBrand = props?.CspBrand;
  const [editOpen, setEditOpen] = useState(false);
  const [EditData, setEditData] = useState(null);
  const [dropdownValue, setDropdownValue] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [Error, setError] = useState(false);
  const [DialogOpen, setDialogOpen] = useState(false);
  const [FilesMap, setFilesMap] = useState([]);
  const [ImageUrl, setImageUrl] = useState(null);
  const [ImageType, setImageType] = useState('');

  const columns = [
    {
      field: 'request_id',
      headerName: 'Application ID',
      width: 120
    },
    {
      field: 'Bank',
      headerName: 'Bank Name',
      width: 100
    },
    {
      field: 'Code',
      headerName: 'CSP Code',
      type: 'number',
      width: 100,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'agent_code',
      headerName: 'Agent Code',
      width: 120
    },

    {
      field: 'agent_name',
      headerName: 'CSP name',
      width: 150
    },
    {
      field: 'approved_at',
      headerName: 'Last branding Approved dates',
      width: 200,
      cellClassName: 'center-align-cell'
    },
    // {
    //   field: 'total_branding',
    //   headerName: 'Total branding received',
    //   type: 'number',
    //   width: 180,
    //   cellClassName: 'center-align-cell'
    // },
    {
      field: 'purchased_from',
      headerName: 'Purchased from',
      width: 150
    },
    {
      field: 'language',
      headerName: 'Language',
      width: 120
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 120
    },
    {
      field: 'status',
      headerName: 'Final Status',
      width: 120,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={
            params.row.status === 'Pending'
              ? 'warning'
              : params.row.status === 'Rejected'
              ? 'error'
              : params.row.status === 'Approved'
              ? 'success'
              : 'primary'
          }
        />
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => (
        <ButtonGroup size="small">
          <Button
            endIcon={<VscEye />}
            sx={{
              borderColor: '#688B2A',
              color: '#688B2A',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#688B2A'
              }
            }}
            onClick={() => handleDialogOpen(params.row.files)}
            color="secondary"
          >
            View
          </Button>
          <Button
            endIcon={<EditOutlinedIcon />}
            sx={{
              borderColor: '#688B2A',
              color: '#688B2A',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#688B2A'
              }
            }}
            color="secondary"
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>
        </ButtonGroup>
      )
    }
  ];

  const handleDialogOpen = (file) => {
    setFilesMap(file);
    setDialogOpen(true);
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const handleEdit = (data) => {
    setEditOpen(true);
    setEditData(data);
  };

  const handleClick = () => {
    setDropdownValue(null);
    setEditOpen(null);
    setEditData(null);
    setEditOpen(false);
  };
  const handleSubmit = () => {
    if (EditData) {
      if (dropdownValue) {
        BrandStatusUpdate(EditData, dropdownValue, setIsLoading, setSuccess, setError, handleClick, props.refunctionwith);
      } else {
        alert('please select the status');
      }
    }
  };
  const formattedName = (value) => {
    if (!value) return ''; // Handle null or undefined values

    // Convert to lowercase and capitalize the first letter of each word
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const rows = Array.isArray(CspBrand)
    ? CspBrand.map((item) => ({
        // id: index || '-', // unique id
        request_id: item.request_id || '-',
        Bank: item.product_name || '-',
        Code: item.csp_code || '-',
        agent_code: item.agent_code || '-',
        agent_name: item.agent_name || '-',
        language: item.language || '-',
        approved_at: item?.reviewed_by?.reviewed_at ? formatDate(item?.reviewed_by?.reviewed_at) : '-',
        // total_branding: (CspBrand && CspBrand?.length) || '-',
        date_of_purchase: item.date_of_purchase || '-',
        purchased_from: item.purchased_from || '-',
        status: formattedName(item.status) || '-',
        created_at: formatDate(item.created_at) || '-',
        remarks: item.remarks || '-',
        user_id: item.user_id,
        // files: [...(item.files || [])]
        files: item.files ? [...item.files] : []
      }))
    : [];

  return (
    <>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Success}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      {/* status update */}
      <Dialog open={editOpen} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 'bold', fontSize: 20, paddingBottom: 2 }}>Final Status</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            setDropdownValue(null);
            setEditOpen(null);
            setEditData(null);
          }}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {/* <Grid container spacing={3}> */}
          <Grid xs={6}>
            <TextField
              label="Status"
              variant="outlined"
              select
              fullWidth
              value={dropdownValue}
              onChange={(e) => setDropdownValue(e.target.value)}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="approved">Approved</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </TextField>
          </Grid>

          {/* </Grid> */}
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <LoadingButton
            loading={IsLoading}
            sx={{
              width: '50%',
              backgroundColor: '#688B2A',
              color: '#fff',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B2A'
              }
            }}
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
          >
            submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {/* {CspBrand && CspBrand.length > 0 ? ( */}
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
              page: 0
            }
          }
        }}
        sx={{
          '& .center-align-cell': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          },
          '& .MuiDataGrid-columnHeaders': {
            color: '#592375'
          }
        }}
        autoHeight
        pageSizeOptions={[5, 50, 100]} // Allow user to choose from these options
        rowCount={props.TotalCount}
        paginationMode="server"
        onPaginationModelChange={(paginationModel) => {
          props.setPage(paginationModel.page); // Update the current page
          props.setRowsPerPage(paginationModel.pageSize); // Update the rows per page
        }}
        getRowId={(row) => row.request_id}
        disableRowSelectionOnClick
      />

      <Dialog
        open={DialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setFilesMap([]);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle variant="h4">
          {ImageUrl ? 'Preview' : 'Documents'}
          <IconButton
            onClick={() => {
              if (ImageUrl) {
                // Close only preview
                setImageUrl('');
                setImageType('');
              } else {
                // Close the dialog fully
                setDialogOpen(false);
                // setFilesMap([])
              }
            }}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {ImageUrl ? (
            // --- Preview Mode (Image or PDF) ---
            <Box sx={{ width: '100%', height: '500px' }}>
              {ImageType === 'pdf' ? (
                <iframe src={ImageUrl} title="PDF Viewer" style={{ width: '100%', height: '100%', border: 'none' }} />
              ) : (
                <img src={ImageUrl} alt="img" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              )}
            </Box>
          ) : (
            // --- Document List Mode ---
            <Stack spacing={2} sx={{ width: '100%', padding: 2 }}>
              <Grid container spacing={2}>
                {FilesMap?.map((file, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <LoadingButton
                      fullWidth
                      variant="outlined"
                      onClick={() => BrandView(file, setImageUrl, setImageType, () => {}, setIsLoading, setError)}
                      color="secondary"
                      startIcon={<FaImage />}
                      sx={{
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                      loading={IsLoading}
                    >
                      <Typography noWrap sx={{ maxWidth: '100%' }}>
                        {file
                          ? (() => {
                              const text = file.split('/').pop();
                              return text.length > 30 ? text.slice(20) : text;
                            })()
                          : ''}
                      </Typography>
                    </LoadingButton>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

WithCsp.propTypes = {
  refunctionwith: PropTypes.object,
  CspBrand: PropTypes.array, // Adjust type based on actual data type
  TotalCount: PropTypes.number,
  setPage: PropTypes.func,
  setRowsPerPage: PropTypes.func
};
export default WithCsp;
